import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { cn } from "@theprelude/core";
import { Checkbox, Truncate } from "../../main";

export const Dropdown = DropdownMenu.Root;
export const DropdownTrigger = DropdownMenu.Trigger;
export const DropdownSub = DropdownMenu.Sub;
export const DropdownSubTrigger = DropdownMenu.SubTrigger;

export const DropdownItemIndicator = DropdownMenu.ItemIndicator;
export const DropdownRadioGroup = DropdownMenu.RadioGroup;

export const DropdownContent: React.FC<
  DropdownMenu.DropdownMenuContentProps
> = ({ children, className, sideOffset = 8, ...props }) => {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        {...props}
        sideOffset={sideOffset}
        className={cn(
          "bg-surface-background border-stroke-line data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-bottom-2 data-[side=top]:slide-in-from-top-2 data-[side=left]:slide-in-from-left-2 data-[side=right]:slide-in-from-right-2 z-40 overflow-hidden rounded border",
          className,
        )}
      >
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  );
};

export const DropdownSubContent: React.FC<
  DropdownMenu.DropdownMenuSubContentProps
> = ({ children, className, ...props }) => {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.SubContent
        {...props}
        className={cn(
          "bg-surface-background border-stroke-line data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-bottom-2 data-[side=top]:slide-in-from-top-2 data-[side=left]:slide-in-from-left-2 data-[side=right]:slide-in-from-right-2 z-50 overflow-hidden rounded border",
          className,
        )}
      >
        {children}
      </DropdownMenu.SubContent>
    </DropdownMenu.Portal>
  );
};

export const DropdownLabel: React.FC<DropdownMenu.DropdownMenuLabelProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <DropdownMenu.Label
      {...props}
      className={cn("text-secondary-foreground text-xs", className)}
    >
      {children}
    </DropdownMenu.Label>
  );
};

export const DropdownItem: React.FC<DropdownMenu.DropdownMenuItemProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <DropdownMenu.Item
      {...props}
      className={cn(
        "bg-surface-background hover:bg-secondary-background min-w-0 cursor-pointer p-2 text-sm outline-none",
        props.disabled && "text-secondary-foreground cursor-not-allowed",
        className,
      )}
    >
      <Truncate text={children}>{children}</Truncate>
    </DropdownMenu.Item>
  );
};

export const DropdownRadio: React.FC<
  DropdownMenu.DropdownMenuRadioItemProps
> = ({ children, className, ...props }) => {
  return (
    <DropdownMenu.RadioItem
      {...props}
      className={cn(
        "bg-surface-background hover:bg-secondary-background data-[state=checked]:bg-tertiary-background cursor-pointer truncate p-2 text-sm outline-none data-[state=checked]:font-medium data-[state=checked]:text-white",
        className,
      )}
    >
      {children}
    </DropdownMenu.RadioItem>
  );
};

export const DropdownCheckbox: React.FC<
  DropdownMenu.DropdownMenuCheckboxItemProps
> = ({ children, checked, className, ...props }) => {
  return (
    <DropdownMenu.CheckboxItem
      checked={checked}
      {...props}
      className={cn(
        "bg-surface-background hover:bg-secondary-background flex cursor-pointer items-center gap-2 truncate p-2 text-sm outline-none",
        className,
      )}
    >
      <span className="left-2 flex h-3.5 w-3.5 shrink-0 items-center justify-center">
        <Checkbox checked={checked} />
      </span>
      {children}
    </DropdownMenu.CheckboxItem>
  );
};

export const DropdownSeparator: React.FC<
  DropdownMenu.DropdownMenuSeparatorProps
> = ({ className, ...props }) => {
  return (
    <DropdownMenu.Separator
      {...props}
      className={cn("border-stroke-line border-b", className)}
    />
  );
};
